import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { SharingSchedulesListItem } from "../../sharing.types";
import { requestSharingSchedules } from "./sharingSchedules.request";

const useSharingSchedules = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<SharingSchedulesListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["admin", "product-sharings", "schedules", requestParams],
    queryFn: async () => await requestSharingSchedules(requestParams),
    ...options
  });

  return { sharingSchedules: data?.data, meta: data?.meta, ...rest };
};

export default useSharingSchedules;
